'use strict';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import TableRow from './TableRow.jsx';
import TableRowDesplegable from './TableRowDesplegable.jsx';

class TableBody extends Component {

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    constructor(props) {
        super(props);

        this.state = {
            entidadInstanciaId: 0,
            filaClickeadaEnModoDesplegable: false,
        }

        this.mostrarFilaEnModoDesplegable = this.mostrarFilaEnModoDesplegable.bind(this);
    }

    mostrarFilaEnModoDesplegable(entidadInstanciaId, filaEnModoDesplegable) {
        /*Si filaEnModoDesplegable es true, quiere decir que se hizo click en la misma fila para ocultarla*/
        this.setState({
            entidadInstanciaId: entidadInstanciaId,
            filaClickeadaEnModoDesplegable: filaEnModoDesplegable,
        });
    }

    render() {
        const { state, props, mostrarFilaEnModoDesplegable } = this;
        const { propiedadInstancia, entidadInstancia, cantidadRegistrosEntidad, soloLectura } = props;
        let nodosInstancia = [];

        if (cantidadRegistrosEntidad > 0){
            if (propiedadInstancia.length > 0) {
                let instanciasUnicas = propiedadInstancia.filter((pinst, index, self) => {
                    return self.map((s) => s.EntidadInstanciaId).indexOf(pinst.EntidadInstanciaId) == index;
                });

                instanciasUnicas.forEach((instUnica, index) => {
                    const isWhiteRow = index % 2 == 0;
                    let propiedadesEncontradas = propiedadInstancia.filter(pinst => pinst.EntidadInstanciaId == instUnica.EntidadInstanciaId);
                    let equivalenciasEncontradas = entidadInstancia.filter(einst => einst.ENTIDAD_INSTANCIA_ID == instUnica.EntidadInstanciaId);
                
                    let modoDesplegable = instUnica.EntidadInstanciaId == state.entidadInstanciaId && !state.filaClickeadaEnModoDesplegable;
                
                    nodosInstancia.push(
                        <TableRow
                            key={`table-row-vista-${instUnica.EntidadInstanciaId}`}
                            parametro={propiedadesEncontradas}
                            entidadInstanciaId={instUnica.EntidadInstanciaId}
                            filaEnModoDesplegable={modoDesplegable}
                            isWhiteRow={isWhiteRow}
                            mostrarFilaEnModoDesplegable={mostrarFilaEnModoDesplegable}
                            tooltip={`Inactivo`}
                        />
                    );
                
                    if (modoDesplegable) {
                        nodosInstancia.push(
                            <TableRowDesplegable
                                key={`table-row-vista-desplegable-${instUnica.EntidadInstanciaId}`}
                                parametro={propiedadesEncontradas}
                                parametroEquivalencia={equivalenciasEncontradas}
                                filaEnModoDesplegable={modoDesplegable}
                                mostrarFilaEnModoDesplegable={mostrarFilaEnModoDesplegable}
                                setearEntidadInstancia={props.setearEntidadInstancia}
                                soloLectura={soloLectura}
                            />
                        );
                    }
                });
            }
        }

        return (
            <tbody>
                {nodosInstancia}
            </tbody>
        );
    }
}

export default TableBody